import BrandTitle from '@modules/common/components/brand-title';
import Breadcrumbs from '@modules/common/components/breadcrumbs';
import Container from '@modules/common/components/container';

const breadcrumbsItems = [
  { name: '首頁', href: '/' },
  { name: '聯絡我們', href: '' },
];

export default function ContactPage() {
  return (
    <Container className="mb-[75px] mt-12 flex flex-col gap-12">
      <Breadcrumbs items={breadcrumbsItems} />
      <div className="self-center">
        <BrandTitle title="聯絡我們" />
      </div>
      <div className="text-black-20 flex flex-col gap-8 self-center text-center">
        <div>若您有任何疑問或需要協助，請透過以下方式與我們聯繫：</div>
        <div>
          客服郵箱：marxpath@marxbiotech.com
          <br />
          客服電話：02-82455250（服務時間：週一至週五，9:00至18:00）
        </div>
        <div>感謝您的聯繫，期待盡快為您服務！</div>
      </div>
    </Container>
  );
}
